import { MoovStepScheduleDTO } from "../DTO/moovStepScheduleDTO";

export class MoovStepSchedule{
    public id!: number;
    public executeOnOrAfter!: Date;
    public startedAt!: Date;
    public finishedAt!: Date;
    public inProgress!: boolean;
    public finished!: boolean;

    

    public static mapFromDTO(param:MoovStepScheduleDTO):MoovStepSchedule{ 
        if (!param) throw new Error("parameter is null")
        let obj = new MoovStepSchedule();
        try
        {
            obj.id = param.id;
            obj.executeOnOrAfter = new Date(param.executeOnOrAfter);
            obj.startedAt = new Date(param.startedAt);
            obj.finishedAt = new Date(param.finishedAt);
            obj.inProgress = param.inProgress;
            obj.finished = param.finished;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:MoovStepSchedule):MoovStepScheduleDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new MoovStepScheduleDTO();
        try
        {
            dto.id = param.id;
            dto.executeOnOrAfter = param.executeOnOrAfter.toISOString();
            dto.startedAt = param.startedAt.toISOString();
            dto.finishedAt = param.finishedAt.toISOString();
            dto.inProgress = param.inProgress;
            dto.finished = param.finished;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    get canRushExecution(){
        return !this.finished && !this.inProgress && (this.executeOnOrAfter.getTime()>(new Date()).getTime())
    }
}